/**
 * Product Service - API calls for products and categories
 */

import api from './api';

// Categories
export const getCategories = () => api.get('/products/categories');

export const getCategoryBySlug = (slug) => api.get(`/products/categories/${slug}`);

export const getProductsByCategory = (slug, params = {}) => {
  const query = new URLSearchParams(params).toString();
  return api.get(`/products/categories/${slug}/products${query ? `?${query}` : ''}`);
};

// Products
export const getProducts = (params = {}) => {
  if (!params.limit) params.limit = 200;
  const query = new URLSearchParams(params).toString();
  return api.get(`/products${query ? `?${query}` : ''}`);
};

// Admin catalogue reads follow `pagination` rather than a fixed `limit`, so a page can
// never silently render a TRUNCATED catalogue beside a confident wrong count (card 54160:
// 213 products, `?limit=200` returned 200 rows and the header read "200 products"). Raising
// the limit is not the fix - the API resolves per-product order counts through a PostgREST
// `in.(...)` filter, so asking for the whole catalogue in one page 500s `URI too long`.
export const ADMIN_PRODUCT_PAGE_SIZE = 200;

export const fetchAllAdminProducts = async () => {
  const first = await api.get(`/admin/products?page=1&limit=${ADMIN_PRODUCT_PAGE_SIZE}`);
  const totalPages = first?.pagination?.totalPages ?? 1;
  const rest = await Promise.all(
    Array.from({ length: Math.max(0, totalPages - 1) }, (_, index) =>
      api.get(`/admin/products?page=${index + 2}&limit=${ADMIN_PRODUCT_PAGE_SIZE}`)
    )
  );
  return { ...first, products: [first, ...rest].flatMap((res) => res?.products ?? []) };
};

export const getProductBySlug = (slug, options = {}) => { const params = options.preview ? `?preview=${options.preview}` : ''; return api.get(`/products/${slug}${params}`); };

export const getFeaturedProducts = (limit = 4) => 
  api.get(`/products/featured?limit=${limit}`);

export default {
  getCategories,
  getCategoryBySlug,
  getProductsByCategory,
  getProducts,
  fetchAllAdminProducts,
  getProductBySlug,
  getFeaturedProducts
};


// Catalog settings
export const getCatalogSettings = () => api.get('/products/catalog-settings');
